import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IFormSelect, IFormSelectOption } from '../../_shared/models/form/form-select.model';
import { FormElementBase } from '../_directives/form-element-base.directive';
import { ReactiveFormsModule } from '@angular/forms';

import { SelectComponent } from '../../select/select.component';

@Component({
    selector: 'sirius-form-select',
    templateUrl: './form-select.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, SelectComponent]
})
export class FormSelectComponent extends FormElementBase implements OnInit {
    config?: IFormSelect;

    @Input() placeholder = '';
    @Input() options: IFormSelectOption[] = [];

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
            this.placeholder = this.config.placeholder;
            this.options = this.config.options;
        }
    }
}
